module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "top2"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rfor"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041791_Foreword"
    }
  }, [_c('i', [_vm._v("Foreword: What a Wedding Song Tells Me / Alejandro L. Madrid")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "racn"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041791_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rint"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041791_Introduction"
    }
  }, [_vm._v("Introduction: Say YES to US: Music in Diasporic Weddings / "), _c('i', [_vm._v("Inna Naroditskaya")])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Theoretical Perspectives on Weddings, Locally and Beyond / "), _c('i', [_vm._v("A. J. Racy")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Negotiating Gender, Community, and Ethnicity: Balkan Romani Transnational Weddings / "), _c('i', [_vm._v("Carol Silverman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Dissonant Love: Music in Latina/o Diasporic Weddings / "), _c('i', [_vm._v("Lorena Alvarado and Frances R. Aparicio")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Tambura Music, Flags, and the Deterritorialization of Ritualized Violence at Croatian American Weddings / "), _c('i', [_vm._v("Ian MacMillen")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Like an "), _c('i', [_vm._v("Erhu")]), _vm._v(" Player on the Roof: Music and Multilayered Diasporic Negotiation at a Taiwanese and Jewish American Wedding / "), _c('i', [_vm._v("Meredith Schweig")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Song, "), _c('i', [_vm._v("Sevdah")]), _vm._v(", and Ceremony: An Autoethnographic Exploration of Music and Community Cohesion in Bosnian American Weddings / "), _c('i', [_vm._v("Tanya Merchant")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Soulful Same-Sex Wedding, Aretha Franklin, Love, and the Politics of (Un)freedom / "), _c('i', [_vm._v("Nina C. Öhman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Trying to Get the Gig: “Ethnic” Weddings from the Musician’s Perspective / "), _c('i', [_vm._v("Michael Allemana")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_2",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Jewish Wedding Music in the Neo-Klezmer Era / "), _c('i', [_vm._v("Hankus Netsky")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Sound Unions: The Work of Music Specialists in Chicago’s South Asian Wedding Scene / "), _c('i', [_vm._v("Kaley Mason and Ameera Nimjee")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041791_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Mountain Weddings in Chicago / "), _c('i', [_vm._v("Timothy J. Cooley")])])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041791_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f420bce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041791_Contents.vue
// module id = 72
// module chunks = 0